<template>
  <div class="ta-bid-created-modal-bid-date">
    <div v-if="show === 'time' || show === 'both'" class="ta-bid-created-modal-data ta-bid-time">
      <div class="ta-data-label">
        {{ $t('Time of Bid') }}
      </div>
      <div class="ta-data-value">
        {{bidCreatedModal.bid.created_at | time}}
      </div>
    </div>
    <div v-if="show === 'date' || show === 'both'" class="ta-bid-created-modal-data ta-bid-date">
      <div class="ta-data-label">
        {{ $t('Date of Bid') }}
      </div>
      <div class="ta-data-value">
        {{bidCreatedModal.bid.created_at | date}}
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "BidDate",
  props: {
    show: {
      type: String,
      default: 'both'
    }
  },
  computed: {
    ...mapState(['bidCreatedModal']),
  }
}
</script>

<style scoped>

</style>
